import React from 'react';
import {Card, CardContent, List, ListItem, ListItemIcon, ListItemText, ListItemButton } from '@mui/material';
import PeopleAltIcon from '@mui/icons-material/PeopleAlt';
import SecurityIcon from '@mui/icons-material/Security';
import PermDataSettingIcon from '@mui/icons-material/PermDataSetting';
import RemoveCircleIcon from '@mui/icons-material/RemoveCircle';

const MemberMenu = (props) => {

    const {changeMembers} = props;

    const switchMembers = (type) => {
        changeMembers(type)
    }

    return(
        <Card>
            <CardContent>
                <List component="nav" aria-label="main mailbox folders">
                    <ListItemButton  onClick={() => switchMembers('allMembers')}>
                        <ListItemIcon>
                            <PeopleAltIcon />
                        </ListItemIcon>
                        <ListItemText primary="All Members" />
                    </ListItemButton>
                    <ListItemButton  onClick={() => switchMembers('admin')}>
                        <ListItemIcon>
                            <SecurityIcon />
                        </ListItemIcon>
                        <ListItemText primary="Admin Members" />
                    </ListItemButton>
                    <ListItemButton  onClick={() => switchMembers('team')}>
                        <ListItemIcon>
                            <PermDataSettingIcon />
                        </ListItemIcon>
                        <ListItemText primary="Team Members" />
                    </ListItemButton>
                    <ListItemButton  onClick={() => switchMembers('deleted')}>
                        <ListItemIcon>
                            <RemoveCircleIcon />
                        </ListItemIcon>
                        <ListItemText primary="Removed members" />
                    </ListItemButton>
                </List>

            </CardContent>
        </Card>
    )
}

export default MemberMenu;